import React from "react"
import PropTypes from "prop-types"
import { amber500 } from "material-ui/styles/colors"

const propTypes = {
    validArray: PropTypes.array,
    onClick: PropTypes.func,
    step: PropTypes.number
}

export default class I9Progress extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            progressWidth: "15%"
        }

        this.onClick0 = this.onClick0.bind(this)
        this.onClick1 = this.onClick1.bind(this)
        this.onClick2 = this.onClick2.bind(this)
        this.onClick3 = this.onClick3.bind(this)
    }

    getValidArray() {
        if (this.props.validArray) {
            return this.props.validArray
        } else {
            return [false, false, false, false]
        }
    }

    onClick0() {
        if (this.props.onClick) {
            this.props.onClick(0)
        }
    }
    onClick1() {
        if (this.props.onClick) {
            this.props.onClick(1)
        }
    }
    onClick2() {
        if (this.props.onClick) {
            this.props.onClick(2)
        }
    }
    onClick3() {
        if (this.props.onClick) {
            this.props.onClick(3)
        }
    }

    render() {
        return (
            <div className="I9Progress" style={{ fontSize: 20, color: "#cccccc", margin: "0 auto" }}>
                {!this.getValidArray()[0] ? (
                    <i className="fa fa-circle-o" aria-hidden="true" style={{ color: amber500, display: "inline-block" }} onTouchTap={this.onClick0} />
                ) : (
                    <i className="fa fa-check-circle-o" aria-hidden="true" style={{ color: "#27ae60", display: "inline-block" }} onTouchTap={this.onClick0} />
                )}
                <div
                    style={{
                        width: this.state.progressWidth,
                        height: "3px",
                        backgroundColor: this.props.step > 0 ? (this.getValidArray()[0] ? "#27ae60" : amber500) : "#cccccc",
                        display: "inline-block",
                        marginBottom: 7
                    }}
                />

                {!(this.getValidArray()[1] && this.props.step > 0) ? (
                    <i
                        className="fa fa-circle-o"
                        aria-hidden="true"
                        style={{
                            display: "inline-block",
                            color: this.props.step > 0 ? amber500 : "#cccccc"
                        }}
                        onTouchTap={this.onClick1}
                    />
                ) : (
                    <i className="fa fa-check-circle-o" aria-hidden="true" style={{ color: "#27ae60", display: "inline-block" }} onTouchTap={this.onClick1} />
                )}
                <div
                    style={{
                        width: this.state.progressWidth,
                        height: "3px",
                        backgroundColor: this.props.step > 1 ? (this.getValidArray()[1] ? "#27ae60" : amber500) : "#cccccc",
                        display: "inline-block",
                        marginBottom: 7
                    }}
                />

                {!(this.getValidArray()[2] && this.props.step > 1) ? (
                    <i
                        className="fa fa-circle-o"
                        aria-hidden="true"
                        style={{
                            display: "inline-block",
                            color: this.props.step > 1 ? amber500 : "#cccccc"
                        }}
                        onTouchTap={this.onClick2}
                    />
                ) : (
                    <i className="fa fa-check-circle-o" aria-hidden="true" style={{ color: "#27ae60", display: "inline-block" }} onTouchTap={this.onClick2} />
                )}
                <div
                    style={{
                        width: this.state.progressWidth,
                        height: "3px",
                        backgroundColor: this.props.step > 2 ? (this.getValidArray()[2] ? "#27ae60" : amber500) : "#cccccc",
                        display: "inline-block",
                        marginBottom: 7
                    }}
                />

                {!(this.getValidArray()[3] && this.props.step > 2) ? (
                    <i
                        className="fa fa-circle-o"
                        aria-hidden="true"
                        style={{
                            display: "inline-block",
                            color: this.props.step > 2 ? amber500 : "#cccccc"
                        }}
                        onTouchTap={this.onClick3}
                    />
                ) : (
                    <i className="fa fa-check-circle-o" aria-hidden="true" style={{ color: "#27ae60", display: "inline-block" }} onTouchTap={this.onClick3} />
                )}
            </div>
        )
    }
}

I9Progress.propTypes = propTypes
